


export class MainBookingContext {

    public routeTo: string[] = [];
    public isFromDestinationDetail: boolean = false; // this state is used to skip search flow and navigate directly to select offer flow for book now from destination detail page
    public userName: string = "";
    constructor() {
    }
}